// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__tN143","sidebar--header":"Sidebar_sidebar--header__zERDx"};